import { Logo } from "src/components/atoms/Logo";

import styles from "src/components/organisms/MobileAuthHeader/styles.module.css";

import { User } from "src/components/molecules/User";
import React from "react";
import { Button, BUTTONTYPE } from "src/components/atoms/Button";
import { NotificationDropdown } from "../NotificationDropdown";
import { useRedirect } from "src/navigation/useRedirect";
import { MODALS } from "src/types/navigation";
import { useSelector } from "react-redux";
import { RootState } from "src/store";
import { isTelegramWebApp } from "src/utils/telegramWebApp";

type Props = {
  handleCollapseMenu: () => void;
  openOnboardingModal?: () => void;
};

export const MobileAuthHeader: React.FC<Props> = ({
  handleCollapseMenu,
  openOnboardingModal,
}) => {
  const { openModal } = useRedirect();
  const user = useSelector((state: RootState) => state.profile.user);
  const isLoggined = user?.id;

  const params = new URLSearchParams(window.location.search);
  const isTgVersion = params.get("tg") === "1" || isTelegramWebApp();

  return (
    <header className={styles.header}>
      <Logo />
      <div className={styles.infoContainer}>
        {isLoggined ? (
          <div className={styles.loginedWrapper}>
            <NotificationDropdown />
            <User
              handleCollapseMenu={handleCollapseMenu}
              openOnboardingModal={openOnboardingModal}
            />
          </div>
        ) : !isTgVersion ? (
          <div className={styles.loginBtns}>
            <Button
              btnType={BUTTONTYPE.LIGHT}
              onClick={() => openModal({ scheme: MODALS.SIGN_IN })}
              text={{ id: "components.organisms.AuthHeader.login" }}
            />
          </div>
        ) : null}
      </div>
    </header>
  );
};
